// extracted by mini-css-extract-plugin
module.exports = {"container":"radio-switch_container__3nwWF","item":"radio-switch_item__W9OzG","selected":"radio-switch_selected__1iHOd"};